class MFooter extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector(".m-footer--accordion");
    const t = document.querySelector(".m-mobile-sticky-bar");

    // Define media query for 1100px breakpoint
    const mqlMobile = window.matchMedia("(max-width: 1100px)");

    // Initialize accordion and sticky bar height for screens matching the query
    if (e) {
      if (mqlMobile.matches) {
        this.acc = new MinimogLibs.Accordion(e, { presetContentHeight: true, onload: true });
      }
      mqlMobile.addEventListener("change", (event) => {
        if (event.matches) {
          this.acc = new MinimogLibs.Accordion(e, { presetContentHeight: true, onload: true });
        }
      });
    }

    if (t) {
      const updateStickyBarHeight = () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${t.offsetHeight}px`);
      };

      updateStickyBarHeight();

      mqlMobile.addEventListener("change", (event) => {
        if (event.matches) {
          updateStickyBarHeight();
        } else {
          document.documentElement.style.setProperty("--mobile-sticky-bar-height", "0px");
        }
      });
    }
  }
}

customElements.define("m-footer", MFooter);
